import Layout from "../components/layout/Layout";
import Projects from "../components/project/Projects";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";

export default function Project() {
    return (
        <Layout project={true}>
            <div className="px-10 mt-6">
                <h1 className="text-2xl font-bold">Project Board</h1>
            </div>
            <DndProvider backend={HTML5Backend}>
                <Projects />
            </DndProvider>
        </Layout>
    );
}
